import React from "react";
import './DatePickerSS.css';
import moment from "moment";

function CustomDate(props) {
    const { day, minDate, maxDate, selectedDate, currentMonth, currentYear, handleSelction, dueDate, ShowReasonCodeWindow, ShowReasonCodeWindowPost } = props;
    if (!day) {
        return <span
            id="day"
            className="picker-day-disable"
        ></span>;
    }

    const getClassName = () => {
        const currentDate = moment.utc([currentYear, currentMonth, day]);

        const minDateUTC = minDate ? moment.utc([minDate.getFullYear(), minDate.getMonth(), minDate.getDate()]) : null;
        if (minDateUTC && currentDate.isBefore(minDateUTC, 'day')) {
            return "picker-day-disable";
        }

        const maxDateUTC = maxDate ? moment.utc([maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate()]) : null;
        if (maxDateUTC && currentDate.isAfter(maxDateUTC, 'day')) {
            return "picker-day-disable";
        }
        
        const selectedDateUTC = selectedDate ? moment.utc([selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate()]) : null;
        if (selectedDateUTC && currentDate.isSame(selectedDateUTC, 'day')) {
            return "day-active picker-day";
        }

        if (dueDate) {
            const dueUTC = moment.utc(dueDate).startOf('day');
            const isAfterDueDate = currentDate.isAfter(dueUTC, 'day');
            

            const isBeforeDueDate = currentDate.isBefore(dueUTC, 'day');

            // Case 1: Both windows are defined
            if (ShowReasonCodeWindow > 0 && ShowReasonCodeWindowPost > 0) {
                const reasonCodeStartDate = dueUTC.clone().subtract(ShowReasonCodeWindow, 'days');
                const reasonCodeEndDate = dueUTC.clone().add(ShowReasonCodeWindowPost, 'days');
                if (currentDate.isBefore(reasonCodeStartDate, 'day') || (isAfterDueDate && currentDate.isAfter(reasonCodeEndDate, 'day'))) {
                    return "picker-day-after-due-date";
                }
            }
            // Case 2: Only pre-window is defined
            else if (ShowReasonCodeWindow > 0 && ShowReasonCodeWindowPost === 0) {
                const reasonCodeStartDate = dueUTC.clone().subtract(ShowReasonCodeWindow, 'days');
                if (currentDate.isBefore(reasonCodeStartDate, 'day') || isAfterDueDate) {
                    return "picker-day-after-due-date";
                }
            }
            // Case 3: Only post-window is defined
            else if (ShowReasonCodeWindow === 0 && ShowReasonCodeWindowPost > 0) {
                const reasonCodeEndDate = dueUTC.clone().add(ShowReasonCodeWindowPost, 'days');
                if (isBeforeDueDate || (isAfterDueDate && currentDate.isAfter(reasonCodeEndDate, 'day'))) {
                    return "picker-day-after-due-date";
                }
            }
            // Case 4: Neither window is defined
            else if (ShowReasonCodeWindow === 0 && ShowReasonCodeWindowPost === 0) {
                if (isBeforeDueDate || isAfterDueDate) {
                    return "picker-day-after-due-date";
                }
            }
        }

        return "picker-day";
    };

    const isDisabled = () => {
        const currentDate = moment.utc([currentYear, currentMonth, day]);

        const minDateUTC = minDate ? moment.utc([minDate.getFullYear(), minDate.getMonth(), minDate.getDate()]) : null;
        if (minDateUTC && currentDate.isBefore(minDateUTC, 'day')) {
            return true;
        }

        const maxDateUTC = maxDate ? moment.utc([maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate()]) : null;
        if (maxDateUTC && currentDate.isAfter(maxDateUTC, 'day')) {
            return true;
        }
        return false;
    }


    return (
        <button
            id="day"
            data-day={day}
            disabled={isDisabled()}
            className={getClassName()}
            onClick={(e) => handleSelction(e)}
        >
            {day}
        </button>
    );
}

export default CustomDate;
